import React from 'react'
import { Typography, List } from '@material-ui/core'
import formatCurrency from 'utils/formatCurrency'
import ContributionListItem from 'components/MyGivingPage/ContributionListItem'
import formatDateString from 'utils/formatDateString'
import useTransactionListItemSelector from 'hooks/useTransactionListItemSelector'
import useCurrentUserEntities from 'hooks/useCurrentUserEntities'

export default function Confirmed() {
  const transactionSelector = useTransactionListItemSelector('Tithe')
  const tithes = useCurrentUserEntities('tithes', 'mostRecentProcessedTithes').slice(0, 5)

  return (
    <List subheader={<Typography variant='subtitle2'>Confirmed</Typography>}>
      {tithes.map(({ amount, id, percentage }) => {
        const { encodedBankLogo, transactionName, accountName, transactionDate, transactionAmount } = transactionSelector(id)
        const primaryText = `${formatDateString(transactionDate)} ~ ${percentage}% of ${formatCurrency(transactionAmount)}`

        return (
          <React.Fragment key={id}>
            <ContributionListItem
              { ...{
                primaryText,
                encodedBankLogo,
                transactionName,
                accountName,
                contribution: formatCurrency(amount)
              } }
            />
          </React.Fragment>
        )
      })}
    </List>
  )
}
